/* ============================================
   Dhenika — FEATURES DATA
   Add or edit features here only.
   ============================================ */

const features = [
  {
    id: 1,
    icon: '🐄',
    iconBg: 'green',
    title: 'Animal Profiles',
    description:
      'Store complete details for every cow and pet — name, breed, age, weight and full history in one tap.',
  },
  {
    id: 2,
    icon: '💉',
    iconBg: 'amber',
    title: 'Vaccination Records',
    description:
      'Log every vaccine given with date and type. Never miss a scheduled vaccination with smart alerts.',
  },
  {
    id: 3,
    icon: '🩺',
    iconBg: 'green',
    title: 'Medical Records',
    description:
      'Track illnesses, treatments and vet visits. Keep a complete health timeline for every animal.',
  },
  {
    id: 4,
    icon: '🔔',
    iconBg: 'amber',
    title: 'Smart Reminders',
    description:
      'Get notified at the right time for vaccines, deworming, breeding and medical checkups.',
  },
  {
    id: 5,
    icon: '🌿',
    iconBg: 'green',
    title: 'Deworming Tracker',
    description:
      'Schedule and log deworming cycles. Auto-reminders ensure your animals stay parasite-free.',
  },
  {
    id: 6,
    icon: '🌾',
    iconBg: 'amber',
    title: 'Farm Profile',
    description:
      'Create your own farm profile. Manage all your animals from one organized, personal dashboard.',
  },
  {
    id: 7,
    icon: '🐣',
    iconBg: 'green',
    title: 'Breeding Details',
    description:
      'Record breeding dates, partners and expected calving. Full breeding history always at hand.',
  },
];

export default features;